import React from "react";
import { Modal, Button, Table, Badge } from "react-bootstrap";

function EnrollmentDetailsModal({ show, onHide, enrollment }) {
  if (!enrollment) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title as={"h6"}>
          Enrollment Details - {enrollment?.course?.title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Course Details */}
        <div className="mb-4">
          <h6 className="mb-3">Course Information</h6>
          <div className="row">
            <div className="col-md-6">
              <p>
                <strong>Title:</strong> {enrollment?.course?.title}
              </p>
              <p>
                <strong>Price per Participant:</strong> ₦
                {enrollment?.course?.price?.toLocaleString()}
              </p>
            </div>
            <div className="col-md-6">
              <p>
                <strong>Duration:</strong> {enrollment?.course?.duration_hours}
                {" hours"}
              </p>
              <p>
                <strong>Total Enrollment Cost:</strong> ₦
                {enrollment?.total_price?.toLocaleString()}
              </p>
            </div>
          </div>
        </div>

        <hr />

        {/* Participants Table */}
        <div>
          <h6 className="mb-3">
            Participants ({enrollment?.participants?.length})
          </h6>
          <div className="table-responsive">
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Department</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {enrollment?.participants?.map((participant) => (
                  <tr key={participant.id}>
                    <td>
                      {participant.full_name}
                      {participant.is_primary === 1 && (
                        <Badge bg="info" className="ms-2">
                          Primary
                        </Badge>
                      )}
                    </td>
                    <td>{participant.email}</td>
                    <td>{participant.phone || "-"}</td>
                    <td>{participant.department || "-"}</td>
                    <td>
                      <Badge
                        bg={
                          participant.course_enrollment_status === "Completed"
                            ? "success"
                            : participant.course_enrollment_status ===
                              "Certificate Issued"
                            ? "primary"
                            : "warning"
                        }
                      >
                        {participant.course_enrollment_status}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EnrollmentDetailsModal;
